import { PageHeader } from "../../../common/components/PageHeader/PageHeader";
import { useZerezesClubAccount } from "../../../providers/ZerezesClubAccountProvider";
import { CurrentPageActionType } from "../ZClubAccountPageCommon";

export const ZClubAccountPageHeader = () => {

  const {
    currentPageAction,
    refresh,
    search,
    loading
  } = useZerezesClubAccount();

  if (loading) return null;

  switch (currentPageAction) {
    case CurrentPageActionType.ExchangePoints:
      return (
        <PageHeader title={'Resgatar cupom'} />
      );
    case CurrentPageActionType.Search:
      return (
        <PageHeader title={'Localizar cliente'} />
      );
    case CurrentPageActionType.Account:
      return (
        <PageHeader
          title={'Conta de cliente'}
          actions={[
            {
              name: 'refresh',
              title: 'Atualizar',
              icon: 'refresh',
              onClick: refresh
            },
            {
              name: 'search',
              title: 'Localizar cliente',
              icon: 'search',
              onClick: search
            }
          ]}
        />
      );
    default:
      return null;
  }
}